import { Button as MuiButton } from "@mui/material"
import { styled } from "@mui/system"
import PropTypes from "prop-types"
import React from "react"

// Create a styled MuiButton without the rounded prop since that will be
// handled via the sx prop to avoid DOM warnings
const StyledButton = styled(MuiButton)(({ theme, variant = "contained" }) => ({
  textTransform: "none",
  ...(variant === "outlined" && {
    minWidth: "100px",
  }),
  padding: theme.spacing(1, 3),
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
  },
}))

const Button = ({ rounded = true, ...props }) => {
  // Use sx prop to apply rounded styling instead of passing rounded directly
  const sx = {
    ...(rounded && {
      borderRadius: "999px",
    }),
    ...(props.sx || {}),
  }

  return <StyledButton {...props} sx={sx} />
}

Button.propTypes = {
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  rounded: PropTypes.bool,
  "aria-label": PropTypes.string,
  sx: PropTypes.object,
}

export default React.memo(Button)
